import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Chip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

function createActionPlan(root, data, actionPlans) {
    let rows = [];
    for (let [index, actionPlan] of actionPlans.entries()) {
        const { projects, ...rest } = actionPlan;
        const _data = { ...data, actionPlan: rest };
        if (index > 0) {
            _data.objective = null;
            _data.goal = null;
        }
        rows.push(_data);
    }
    return rows;
}

function createGoal(root, data, goals) {
    let rows = [];
    for (const [index, goal] of goals.entries()) {
        const { action_plans: actionPlans, ...rest } = goal;
        const _data = { ...data, goal: rest };
        if (index > 0) {
            _data.objective = null;
        }
        rows = rows.concat(createActionPlan(root, _data, actionPlans));
    }
    return rows;
}

// function createObjectiveData(root, data, objectives) {
//     let rows = [];
//     for (const objective of objectives) {
//         const { goals, ...rest } = objective;
//         rows = rows.concat(createGoal(root, { ...data, objective: rest }, goals));
//     }
//     return rows;
// }

function PlanTable(props) {
    const { strategicPlanning, objective } = props;
    const rows = createGoal(strategicPlanning, { objective }, objective.goals);

    return (
        <Table
            size="small"
            sx={{
                "&, th, td": {
                    border: 1,
                    borderColor: "divider",
                    borderStyle: "solid",
                    borderCollapse: "collapse",
                },
            }}
        >
            <TableHead>
                <TableRow>
                    {/**
                    <TableCell sx={{ width: 350 }}>Objective</TableCell>
                    */}
                    <TableCell sx={{ width: "45%" }}>Goal</TableCell>
                    <TableCell sx={{}}>Action Plan</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows?.map((row, index) => (
                    <TableRow key={index}>
                        {/**
                        <TableCell sx={{ verticalAlign: "top" }}>
                            <Typography gutterBottom>{row.objective?.title}</Typography>
                            <Box>
                                {row.objective?.title && (
                                    <Chip label={row.objective?.code} variant="outlined" size="small" />
                                )}
                            </Box>
                        </TableCell>
                        */}
                        <TableCell sx={{ verticalAlign: "top" }}>
                            <Typography gutterBottom>{row.goal?.title}</Typography>
                            <Box>
                                {row.goal?.title && (
                                    <Chip label={row.goal?.code} variant="outlined" size="small" color="info" />
                                )}
                            </Box>
                        </TableCell>
                        <TableCell sx={{ verticalAlign: "top" }}>
                            <Typography gutterBottom>{row.actionPlan?.title}</Typography>
                            <Box>
                                {row.actionPlan?.title && (
                                    <Chip
                                        label={row.actionPlan?.code}
                                        variant="outlined"
                                        size="small"
                                        color="secondary"
                                    />
                                )}
                            </Box>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}

export default function ObjectiveCard(props) {
    const { strategicPlanning, objective } = props;

    return (
        <Card variant="outlined">
            <CardHeader
                title={
                    <>
                        {objective.title}{" "}
                        <Chip label={objective.code} size="small" variant="outlined" color="primary" />{" "}
                        <Chip label="วัตถุประสงค์" size="small" />
                    </>
                }
            ></CardHeader>
            {/**
            <Divider variant="middle" />
            */}
            <CardContent>
                <PlanTable strategicPlanning={strategicPlanning} objective={objective} />
            </CardContent>
        </Card>
    );
}
